export interface Insertion {
  next: string;
  caret: number;
}

/**
 * Compute the value and caret position after inserting `text` at a textarea
 * selection. Adds a single leading space when the character before the caret
 * is non-whitespace, so dictated fragments do not run into existing words.
 */
export const computeInsertion = (
  value: string,
  selectionStart: number,
  selectionEnd: number,
  text: string,
): Insertion => {
  const before = value.slice(0, selectionStart);
  const after = value.slice(selectionEnd);
  const needsSpace = before.length > 0 && !/\s$/.test(before);
  const insert = `${needsSpace ? ' ' : ''}${text}`;
  return { next: `${before}${insert}${after}`, caret: before.length + insert.length };
};
